import fileDownload from 'js-file-download';

const parseJsonBlob = async (blob) => {
  const text = await blob.text();
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
};

/**
 * Extrai mensagem de erro quando a API retorna JSON em blob (ex. 400 via axios reject).
 */
export async function parseBlobExportError(error, fallbackMessage = 'Erro ao exportar') {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    const parsed = await parseJsonBlob(data);
    if (parsed?.message) return parsed.message;
  }
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  return error?.message || fallbackMessage;
}

/**
 * Baixa blob de resposta HTTP. Se o servidor retornar JSON (ex. 400), parseia e lança Error.
 */
export async function downloadBlobResponse(response, fallbackFilename) {
  const contentType = response.headers['content-type'] || '';

  if (contentType.includes('application/json')) {
    const parsed = await parseJsonBlob(response.data);
    throw new Error(parsed?.message || 'Erro ao exportar');
  }

  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/);
  const filename = match?.[1] || fallbackFilename;
  fileDownload(response.data, filename);
}
